import React, { useState, useEffect } from 'react';
import { settingsAPI, ordersAPI } from '../services/api';
import {
  buildWhatsAppOrderText,
  cartItemsToOrderPayload,
  mergeVehicleForPart,
} from '../utils/whatsappMessage';
import { DEFAULT_WHATSAPP_DIGITS, normalizeWhatsAppDigits } from '../utils/whatsapp';
import CheckoutModal from './CheckoutModal';
import './WhatsAppButton.css';

/**
 * vehicleContext: { modelName, variantName } من صفحة القطع (أولوية على حقول القطعة)
 */
const WhatsAppButton = ({ sparePart, vehicleContext = {} }) => {
  const [whatsappNumber, setWhatsappNumber] = useState(DEFAULT_WHATSAPP_DIGITS);
  const [loading, setLoading] = useState(true);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);

  useEffect(() => {
    fetchWhatsAppNumber();
  }, []);

  const fetchWhatsAppNumber = async () => {
    try {
      const response = await settingsAPI.getSettings();
      const raw = response.data && response.data.whatsapp_number;
      setWhatsappNumber(normalizeWhatsAppDigits(raw));
    } catch (err) {
      console.error('Error fetching WhatsApp number:', err);
      setWhatsappNumber(DEFAULT_WHATSAPP_DIGITS);
    } finally {
      setLoading(false);
    }
  };

  const buildLineItem = () => {
    const v = mergeVehicleForPart(vehicleContext, sparePart);
    return {
      ...sparePart,
      quantity: 1,
      modelName: v.modelName,
      variantName: v.variantName,
      model_name: v.modelName,
      variant_name: v.variantName,
    };
  };

  const handleCheckoutConfirm = async ({ phone, address }, popup) => {
    const line = buildLineItem();
    const message = buildWhatsAppOrderText([line], { phone, address });
    setOrderLoading(true);
    try {
      await ordersAPI.create({
        phone,
        address,
        whatsapp_text: message,
        items: cartItemsToOrderPayload([line]),
      });
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.detail || e.response?.data?.phone?.[0] || 'تعذر حفظ الطلب.');
      setOrderLoading(false);
      try { if (popup && !popup.closed) popup.close(); } catch {}
      return;
    }
    setOrderLoading(false);
    setCheckoutOpen(false);
    const fullNum = normalizeWhatsAppDigits(whatsappNumber).replace(/\D/g, '');
    const encoded = encodeURIComponent(message);
    const url = `https://wa.me/${fullNum}?text=${encoded}`;
    if (popup && !popup.closed) {
      popup.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  };

  const handleClick = () => {
    setCheckoutOpen(true);
  };

  if (loading) {
    return (
      <button className="whatsapp-btn" disabled>
        جاري التحميل...
      </button>
    );
  }

  return (
    <>
      <CheckoutModal
        isOpen={checkoutOpen}
        onClose={() => !orderLoading && setCheckoutOpen(false)}
        onConfirm={handleCheckoutConfirm}
        loading={orderLoading}
        title="إتمام الطلب"
      />
      <button type="button" className="whatsapp-btn" onClick={handleClick}>
        <span className="whatsapp-icon">📱</span>
        إرسال عبر واتساب
      </button>
    </>
  );
};

export default WhatsAppButton;
